interface HTMLElementWithHandler extends HTMLElement {
  _clickableHandler?: (event: MouseEvent) => void;
}

const clickableDirective = {
  mounted(el: HTMLElementWithHandler) {
    el.style.position = 'relative'; // Asegurarse de que el contenedor tenga posición relativa
    el.style.cursor = 'pointer'; // Cambiar el cursor a 'pointer' al ser clickeable

    const handleClick = (event: MouseEvent) => {
      const ripple = document.createElement('div');
      ripple.style.position = 'absolute';
      ripple.style.borderRadius = '50%';
      ripple.style.pointerEvents = 'none';
      ripple.style.backgroundColor = 'rgba(0, 0, 0, 0.3)'; // Color del ripple
      ripple.style.transform = 'scale(0)';
      ripple.style.animation = 'ripple-animation 0.6s linear';

      // Añadir el ripple al contenedor
      el.appendChild(ripple);

      // Calcular el tamaño y la posición del ripple
      const size = Math.max(el.offsetWidth, el.offsetHeight);
      const x = event.clientX - el.getBoundingClientRect().left - size / 2;
      const y = event.clientY - el.getBoundingClientRect().top - size / 2;

      ripple.style.width = `${size}px`;
      ripple.style.height = `${size}px`;
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;

      // Limpiar el ripple después de la animación
      setTimeout(() => {
        ripple.remove();
      }, 600); // Duración de la animación
    };

    el.addEventListener('click', handleClick);

    // Guardar el manejador del evento en la propiedad _clickableHandler
    el._clickableHandler = handleClick;
  },

  unmounted(el: HTMLElementWithHandler) {
    if (el._clickableHandler) {
      el.removeEventListener('click', el._clickableHandler);
    }
  },
};

export default clickableDirective;
